import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import 'rxjs';
import { AuthDataStorageService } from '../services/auth-data-storage.service';

@Injectable()
export class RestrictedUserGuard implements CanActivate {
  private subscription: Subscription;

  constructor(private router: Router, private authDataStorageService: AuthDataStorageService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!this.authDataStorageService.isUserRestricted()) {
      return true;
    }
    this.router.navigateByUrl('/');

    return false;
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/auth/guard/restricted-user.guard.ts